import { notification } from 'antd'
import { definedErrorCodes, handleErrors } from 'helpers'
import axios from './axiosInstance'
import constants from '../constants'

const URL = `${constants.customerDomain}plans`

export default async function getPlans() {
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, { headers: { Authorization: `Bearer ${ccBearerToken}` } })
      return res.data.data
    }
  } catch (error) {
    const errorCode = error.response?.data?.error?.code ?? ''
    const { message, description } = handleErrors(definedErrorCodes(errorCode) ? errorCode : '')
    notification.error({ message, description })
    return true // Indicates request was sent but failed due to some error
  }
  return false // Indicates ccBearerToken was not present in the local storage
}
